import { RequestIndexView } from "components/RequestIndex/RequestIndexView";
import { Alert } from "swing-components";
import { generateSwingSupportURL } from "swing-utils";

import { translate } from "~utils";

import { UseRequestsReturn } from "./hooks";
import { NoRequests } from "./NoRequests";
import styles from "./RequestIndex.module.css";

/** Types */
export type RequestType = "past-requests" | "active-requests";

type RequestIndexProps = {
  requestType: RequestType;
  requests: NonNullable<UseRequestsReturn>["requests"];
  isError?: boolean;
};

/** Component */
export function RequestIndex(props: RequestIndexProps) {
  const { requestType, requests, isError } = props;

  /*** Constants ***/
  const isPastRequest = requestType === "past-requests";

  /*** Render ***/
  if (isError) {
    return (
      <div className={`${styles.centralWrapper}`}>
        <Alert
          showIcon
          className="w-full"
          color="danger"
          title={translate("LABEL_SOMETHING_WENT_WRONG")}
        >
          <>
            {translate("LABEL_CONTACT_SUPPORT_1")}{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href={generateSwingSupportURL("/hc/en-us/requests/new")}
            >
              {translate("LABEL_CONTACT_SUPPORT")}
            </a>{" "}
            {translate("LABEL_CONTACT_SUPPORT_2")}
          </>
        </Alert>
      </div>
    );
  }

  // Return early if there are no requests
  if (requests.length === 0) {
    const noRequestProps = {
      img: {
        src: isPastRequest ? "assets/magnifyingGlass.svg" : "assets/magnifyingGlassWithLadder.svg",
        alt: "Person holding up magnifying glass",
      },
      // TODO: Remove these after feature is out and remove
      // entries from string-table
      headerString: translate("LABEL_NO_RESULTS_HEADER"),
      contentString: translate("LABEL_NO_RESULTS_BODY"),
    };

    return (
      <div className={`${styles.centralWrapper}`}>
        <NoRequests {...noRequestProps} />
      </div>
    );
  }

  return <RequestIndexView requests={requests} requestType={requestType} />;
}
